export default "__VITE_ASSET__t$vZO8PQ__"